<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>

    <section class="addressManually">

        <!-- Building number -->

		  <div class="width-100 mdc-textfield mdc-textfield--upgraded" :class="{'editable-item__required': attentionSymbol && address.buildingNumber === ''}">
			   <input class="mdc-textfield__input" type="text" v-model="address.buildingNumber" placeholder="" :class="{'input--valid': address.buildingNumber !== ''}" @changed="addressChanged" />
			   <label class="mdc-textfield__label mdc-textfield__label--float-above">Building number/name</label>
		  </div>
        <!-- Flat number -->
        <div class="width-100 mdc-textfield mdc-textfield--upgraded">
            <input class="mdc-textfield__input" type="text" v-model="address.flatNumber" :class="{'input--focus': address.flatNumber !== ''}" placeholder="" @changed="addressChanged">
				<label class="mdc-textfield__label mdc-textfield__label--float-above">Enter number/letter if Flat</label>
        </div>

        <!-- Street -->
        <div class="width-100 mdc-textfield mdc-textfield--upgraded" :class="{'editable-item__required': attentionSymbol && address.street === ''}">
            <input class="mdc-textfield__input" type="text" v-model="address.street" placeholder="" :class="{'input--valid': address.street !== ''}" @changed="addressChanged">
            <label class="mdc-textfield__label mdc-textfield__label--float-above">Street</label>
        </div>

    <!-- Town -->
    <div class="width-100 mdc-textfield mdc-textfield--upgraded" :class="{'editable-item__required': attentionSymbol && address.town === ''}">
        <input class="mdc-textfield__input" type="text" v-model="address.town" placeholder="" :class="{'input--valid': address.town !== ''}" @changed="addressChanged">
            <label class="mdc-textfield__label mdc-textfield__label--float-above">Town/City</label>
        </div>

        <!-- County -->
        <div class="width-100 mdc-textfield mdc-textfield--upgraded" :class="{'editable-item__required': attentionSymbol && address.county === ''}">
            <input class="mdc-textfield__input" type="text" v-model="address.county" placeholder="" :class="{'input--valid': address.county !== ''}" @changed="addressChanged">
            <label class="mdc-textfield__label mdc-textfield__label--float-above">District/County</label>
        </div>

        <!-- Postcode -->
        <div class="width-100 mdc-textfield mdc-textfield--upgraded" :class="{'editable-item__required': attentionSymbol && address.postcode === ''}">
            <input class="mdc-textfield__input" type="text" v-model="address.postcode" placeholder="" :class="{'input--valid': address.postcode !== ''}" @changed="addressChanged">
            <label class="mdc-textfield__label mdc-textfield__label--float-above">Full postcode</label>
            <span class="warning-message" v-if="notFullPostcode">Postcode is not complete!</span>
        </div>
    </section>

</template>

<script>

    export default {
        props: {
          value: Object,
			 attentionSymbol: {
				 type: Boolean,
				 default: false
			 },
			 notFullPostcode: false
        },
    		data: function() {
      			return {
                address: this.value,
                defaultAddress: {
                    buildingNumber: '',
                    street: '',
                    postcode: '',
                    flatNumber: '',
                    town: '',
                    county: '',
                    fullAddress: '',
                    shortAddress: ''
                },
					 isNotFullPostcode: false
      			}
    		},
        watch: {
            address: {
              handler: function (newAddress) {
                    this.verifyPostcode();
						  if (this.isNotFullPostcode === false) {
	  						  this.generateLatLng();
						  }
                },
              deep: true
			  }
        },
        created: function() {
          if(Object.keys(this.address).length == 0) {
            this.address = this.defaultAddress;
          }
        },
    		methods: {
            emitAddress: function(){
                this.address.fullAddress = this.fullAddress;
                this.$emit('input', this.address);
            },
            verifyPostcode: function(){
                var filter = /^\s*\w{2,4}\s?\w{3}\s*$/;

					 if(!filter.test(this.address.postcode)){
                        this.isNotFullPostcode = true;
                } else {
                    this.isNotFullPostcode = false;
                }

                this.$emit('notFullPostcode', this.isNotFullPostcode);
            },
				addressChanged: function() {
					this.$emit('changed');
				},
				generateLatLng: function() {
					if (this.address.street !== '' && this.address.postcode !== '') {
						var geocoder = new google.maps.Geocoder();
						var self = this;
						geocoder.geocode({
						    	'address': self.address.street + ", "+self.address.town + ", "+self.address.county + ", "+self.address.postcode,
						    	'componentRestrictions': {
						        		'country': 'gb'
						    	}
						}, function (results, status) {
						    if (status === google.maps.GeocoderStatus.OK) {
						    	self.address.latitude = results[0].geometry.location.lat();
						    	self.address.longitude = results[0].geometry.location.lng();
 	                    	self.emitAddress();
							}
						})
					}
				}
    		},
        computed: {
            fullAddress: function() {
                var address = '';
                if (this.address.buildingNumber != '') {
                    address += this.address.buildingNumber + ', ';
                }
                if (this.address.flatNumber != '') {
                    address += this.address.flatNumber + ' ';
                }
                address += this.address.street + ' ' + this.address.postcode;

                return address;
            },
            shortAddress: function() {
                var address = '';
                if (this.address.flatNumber != '') {
                    address += this.address.flatNumber + ', ';
                }
                if (this.address.buildingNumber != '') {
                    address += this.address.buildingNumber + ' ';
                }
                if (this.address.street != '') {
                    address += this.address.street;
                }

                return address;
            }
        }
  	}

</script>
